module.exports = __webpack_public_path__ + "static/media/logo_wisehamster.8af43abc.png";